<template>
	<form
		:class="[
			'styled-form',
			'styled-form--white-box',
			{'is-loading': isLoading}
		]"
		@submit.prevent="onSubmit"
		autocomplete="off"
	>
		<div v-if="isLoading" class="styled-form__overlay">
			<div class="preloader"></div>
		</div>

		<global-message v-if="errors.global" :value="errors.global"></global-message>
		
		<modal title="Before you create an account…" v-if="dta.isFromRego">
			<register-modal-content />
		</modal>

		<div class="styled-form__header __header-margin" v-if="dta.isFromRego">
			<h2 class="styled-form__title">Create a Football Account to register and play</h2>
		</div>

		<div class="styled-form__header" v-else>
			<h2 class="styled-form__title">Create your Football Account</h2>
			<h3 class="styled-form__subtitle">Your Football Account is one account that lets you connect with all of the Football Network in Australia.</h3>
			<router-link
				class="styled-form__link"
				:to="{name: 'login'}"
			>Already have an account?</router-link>
		</div>

    <social-connect @socialButtonClick="isLoading = true" v-show="!dta.isFromRego" />

		<div class="o-grid o-grid--no-vgutter">

			<div class="o-grid__item o-1/2@largeMobile">
				<form-input
					v-model="data.firstName"
					name="firstName"
					:label="dta.isFromRego ? 'Your First Name *' : 'First Name *'"
					:error="errors.firstName"
				></form-input>
			</div>

			<div class="o-grid__item o-1/2@largeMobile">
				<form-input
					v-model="data.lastName"
					name="lastName"
					:label="dta.isFromRego ? 'Your Last Name *' : 'Last Name *'"
					:error="errors.lastName"
				></form-input>
			</div>

			<div class="o-grid__item">
				<form-input
					v-model="data.email"
					name="email"
					:label="dta.isFromRego ? 'Your Email Address 	*' : 'Email Address  *'"
					:error="errors.email"
					class="to-lower-case"
					@input="emailMatchInline"
					@paste.prevent
				></form-input>
			</div>

			<div class="o-grid__item">
				<form-input
						v-model="data.confirmEmail"
						name="email-confirm"
						label="Confirm Email Address 	*"
						:error="errors.confirmEmail"
						class="to-lower-case"
						@input="emailMatchInline"
						@paste.prevent
				></form-input>
			</div>

			<div class="o-grid__item">
				<form-input
					v-model="data.password"
					type="password"
					name="password"
					label="Create a Password *"
					:error="errors.password"
					@input="passwordPolicyInline"
					@paste.prevent
				></form-input>
				<div class="label2 common__text">Use 8 or more characters with a mix of upper and lower case letters & numbers.</div>
			</div>

			<div class="o-grid__item">
				<form-input
						v-model="data.confirmPassword"
						type="password"
						name="password-confirm"
						label="Confirm Password *"
						:error="errors.confirmPassword"
						@input="passwordMatchInline"
						@paste.prevent
				></form-input>
			</div>

			<div class="o-grid__item o-1/3@tablet">
				<styled-date-picker
					v-model="data.dateOfBirth"
					:label="dta.isFromRego ? 'Your Date of Birth *': 'Date of Birth *'"
					:error="errors.dateOfBirth"
				></styled-date-picker>

			</div>
			<div class="o-grid__item common__text">
				<checkbox-wrapped
						v-model="data.checkIfUserIsOutsideOfAustralia"
						label="Are you registering outside Australia?"
				></checkbox-wrapped>
			</div>
      <div class="o-grid__item o-1/3@tablet">
        <form-input
            v-model="data.postcode"
            :max-length="postcodeLength"
            name="postcode"
            :label="dta.isFromRego ? 'Your Postcode *': 'Postcode *'"
            :error="errors.postcode"
        ></form-input>

      </div>
			<div class="o-grid__item common__text">
				<checkbox-wrapped
						v-model="data.emailOpt"
						label="Receive marketing promotions and special offer emails from Football Australia"
						:error="errors.emailOpt"
				></checkbox-wrapped>
			</div>

			<div class="o-grid__item">
				<div class="styled-form__field">
					<label for="termsAndConditions" class="styled-form__label">Terms and Conditions *</label>
					<div class="tc-container">
						<p class="common__text">Football Australia respects the privacy of individuals about whom we collect personal information. The personal information that Football Australia collects from you via the Football Account registration form is collected for the purposes of processing your registration, sending you information about Football Australia (including information regarding our commercial partners and sponsors and related products and services), information about football matches, tickets and related events, assisting with your enquiries and for other purposes set out in our <a class="common__link common__link--in-text" :href="privacy.link" target="_blank">{{ privacy.text }}</a>.</p>
						<p class="common__text">You acknowledge that the information you provide will be collected by Football Australia and may be given to third parties (such as Ticketek, IT providers or venue operators) we engage to help us run our business for the purposes outlined above or as required by law. Without your personal details, we can’t register you or send you the information you’ve requested. Our <a class="common__link common__link--in-text" :href="privacy.link" target="_blank">{{ privacy.text }}</a> tells you more, including how to contact us to access and correct your details or make a complaint.</p>
						<p class="common__text">By signing up, you consent to the collection, use and disclosure of your personal information as described above.</p>
					</div>
					<checkbox-wrapped
							v-model="data.termsAndConditions"
							label="I have read and accept the terms and conditions"
							:error="errors.termsAndConditions"
					></checkbox-wrapped>
				</div>
			</div>
			<div class="recaptcha-container">
				<div class="recaptcha-wrapper"
					v-bind:class="{'recaptcha-wrapper-invalid' : (errors.recaptcha && errors.recaptcha.length)}">
					<vue-recaptcha
						ref="recaptcha"
						:size="data.reCaptchaSize"
						:loadRecaptchaScript="true"
						badge= 'inline'
						sitekey="6Lc4yaEgAAAAAGP_BEXyHbJYYwuC-t0d-hHfu3l_"
						@verify="onCaptchaVerified"
						@expired="onCaptchaExpired">
					</vue-recaptcha>
				</div>
				<label for="recaptcha" class="styled-form__error is-visible recaptcha-error"
							v-if="errors.recaptcha"
							:error="errors.recaptcha">Please verify you are not a robot.
				</label>
			</div>
			<div class="o-grid__item">
				<div class="text--center">
					<button class="btn" :disabled="isLoading">Register</button>
				</div>
			</div>
		</div>
	</form>
</template>

<style>
	.tc-container {
		padding: 15px 0 20px;
		text-align: justify;
	}
	.__header-margin {
		margin-bottom: 57px !important;
	}
</style>

<script>
	import moment from 'moment';
  import isDisposableEmail from "../../helpers/isDisposableEmail";
  import isEmail from '../../helpers/isEmail';
	import StyledDatePicker from '../formFields/StyledDatePicker.vue';
	import FormInput from '../formFields/FormInput.vue';
	import GlobalMessage from '../messages/GlobalMessage.vue';
	import SocialConnect from '../views/SocialConnect.vue';
	import CheckboxWrapped from '../formFields/CheckboxWrapped.vue';
	import DynamicText from '../views/DynamicTextView.vue';
	import VueRecaptcha from 'vue-recaptcha';
	import Modal from '../modal/CustomModal.vue';
	import RegisterModalContent from '../modal/Register/RegisterModalContent.vue';

	export default {
    components: {
      FormInput,
      StyledDatePicker,
      GlobalMessage,
      SocialConnect,
      CheckboxWrapped,
      DynamicText,
      VueRecaptcha,
      Modal,
      RegisterModalContent,
    },
    props: {
      submit: {
        type: Function,
        required: true
      },
      errorMessage: Object
    },
    data() {
      return {
        isLoading: false,
        data: {
          firstName: '',
          lastName: '',
          email: '',
          password: '',
          dateOfBirth: '',
          postcode: '',
          termsAndConditions: false,
          checkIfUserIsOutsideOfAustralia: false,
          emailOpt: true,
          confirmPassword: '',
          confirmEmail: '',
          recaptchaToken: '',
          reCaptchaSize: '',
          isFirstLogin: true
        },
        privacy: {
          link: 'https://www.ffa.com.au/privacy',
          text: 'Privacy Policy'
        },
        errors: {},
        dta: {
          isFromRego: false,
          info: ''
        },
      }
    },
    computed: {
      postcodeLength() {
        if (this.data.checkIfUserIsOutsideOfAustralia)
          this.errors.postcode = this.validatePostcode(this.data.postcode)
        return this.data.checkIfUserIsOutsideOfAustralia ? 10 : 4
      }
    },
    beforeMount() {
      if (window.innerWidth > 480) {
        this.data.reCaptchaSize = "normal";
      } else {
        this.data.reCaptchaSize = "compact";
      }
    },
    created() {
      this.validateProps();
      this.checkDtaConfig();
    },
    methods: {
      passwordPolicyInline() {
        if (this.data.password.length > 0) {
          let errors = this.validatePassword(this.data.password);
          if (errors.length) {
            this.errors.password = this.passwordPolicyErrorFormat(errors);
          } else {
            delete this.errors.password;
          }
        } else {
          delete this.errors.password;
        }
      },
      passwordPolicyErrorFormat(errors) {
        let errorMsg = "<ul>";
        errors.forEach(function (item) {
          errorMsg = errorMsg + " <li> " + item + "</li>";
        });
        errorMsg = errorMsg + "</ul>";
        return errorMsg;
      },
      passwordMatchInline() {
        if (this.data.confirmPassword.length > 0) {
          let errors = this.validatePasswordMatch(this.data.password, this.data.confirmPassword);
          if (errors !== "") {
            this.errors.confirmPassword = errors;
          } else {
            delete this.errors.confirmPassword;
          }
        } else {
          delete this.errors.confirmPassword;
        }
      },
      emailLowerCase() {
        if (this.data.email.length > 0) {
          this.data.email = this.data.email.toLowerCase();
        }

        if (this.data.confirmEmail.length > 0) {
          this.data.confirmEmail = this.data.confirmEmail.toLowerCase();
        }
      },
      emailMatchInline() {
        if (this.data.confirmEmail.length > 0) {
          this.emailLowerCase();
          this.data.confirmEmail = this.data.confirmEmail.toLowerCase();
          let errors = this.validateEmailMatch(this.data.email, this.data.confirmEmail);
          if (errors !== "") {
            this.errors.confirmEmail = errors;
          } else {
            this.clearEmailErrorMessage();
          }
        } else {
          this.clearEmailErrorMessage();
        }
      },
      clearEmailErrorMessage() {
        this.errors.confirmEmail = "";
        this.errors.email = "";
        delete this.errors.confirmEmail;
        delete this.errors.email;
      },
      validateProps() {
        if (this.errorMessage && this.errorMessage.value) {
          this.errors.global = this.errorMessage.value;
        }
      },
      onSubmit() {
        this.errors = this.validate(this.data);
        if (Object.keys(this.errors).length === 0) {
          this.data.email = this.data.email.toLowerCase();
          this.isLoading = true;
          this.submit(this.data).catch(errors => {
            this.isLoading = false;
            if (errors.hasOwnProperty('login')) {
              // redirect to the login page
              this.$router.push({
                name: 'login',
                params: {
                  issue: errors.login
                }
              });
            } else {
              this.errors = errors;
            }
          });
        }
      },
      validatePassword(password) {
        let errors = [];

        if (!password.length) {
          errors.push('This field is required');
        }
        if (password.length < 8) {
          errors.push('Password must be at least 8 characters');
        }
        if (!(/[a-z]/.test(password))) {
          errors.push('Password must contain at least one lowercase letter');
        }
        if (!(/[A-Z]/.test(password))) {
          errors.push('Password must contain at least one uppercase letter');
        }
        if (!(/[0-9]/.test(password))) {
          errors.push('Password must contain at least one number');
        }
        /*
        if (!(/[!|@|#|$|%|^|&|*|(|)|-|_|]/.test(password))) {
            errors.push('Password must contain at least one special character');
        }
        */

        return errors;
      },
      validatePasswordMatch(password, confirm) {
        let errors = '';

        if (!confirm.length) {
          errors = 'This field is required';
        } else if (password !== confirm) {
          errors = 'The password you entered does not match';
        }
        return errors;
      },
      validateEmailMatch(email, confirm) {
        let errors = '';

        if (!confirm.length) {
          errors = 'This field is required';
        } else if (email !== confirm) {
          errors = 'The email you entered does not match';
        }
        return errors;
      },
      validateDateOfBirth(dateOfBirth) {
        let errors = '';

        let invalidYearsAgo = moment().subtract(115, 'years');
        if (!moment(dateOfBirth, 'YYYY-MM-DD').isValid()) {
          errors = 'This field is required';
        } else if (moment(dateOfBirth, 'YYYY-MM-DD').diff(moment(new Date())) > 0
            || moment(dateOfBirth, 'YYYY-MM-DD').diff(invalidYearsAgo, 'years') <= 0) {
          errors = 'Enter a valid date of birth';
        }
        return errors;
      },
      validatePostcode(postcode) {
        let errors = '';
        if (!this.data.checkIfUserIsOutsideOfAustralia) {
          const regex = new RegExp('^(?:(?:[2-8]\\d|9[0-7]|0?[28]|0?9(?=09))(?:\\d{2}))$');
          if (!postcode) {
            errors = 'This field is required';
          } else if (!regex.test(postcode)) {
            errors = 'Enter a valid postcode';
          }
        }
        return errors;
      },
      validateRecaptcha(token) {
        let recaptchaError = '';
        if (!token.length) {
          recaptchaError = "Please let us know that you are a human."
        }
        return recaptchaError;
      },
      validate(data) {
        const errors = {};

        if (!data.firstName.length) errors.firstName = 'This field is required';
        if (new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?").test(data.firstName)) {
          errors.firstName = 'This field should not contain URL';
        }

        if (!data.lastName.length) errors.lastName = 'This field is required';
        if (new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?").test(data.lastName)) {
          errors.lastName = 'This field should not contain URL';
        }

        if (!data.email.length) {
          errors.email = 'This field is required';
        } else if (!isEmail(data.email) || isDisposableEmail(data.email)) {
          errors.email = 'Invalid email';
        }

        let passwordErrors = this.validatePassword(data.password);
        if (passwordErrors.length) {
          errors.password = this.passwordPolicyErrorFormat(passwordErrors);
        }

        let passwordMatch = this.validatePasswordMatch(data.password, data.confirmPassword);
        if (passwordMatch != "") {
          errors.confirmPassword = passwordMatch;
        }

        let emailMatch = this.validateEmailMatch(data.email, data.confirmEmail);
        if (emailMatch != "") {
          errors.confirmEmail = emailMatch;
        }

        let dateOfBirthErrors = this.validateDateOfBirth(data.dateOfBirth);
        if (dateOfBirthErrors.length) {
          errors.dateOfBirth = dateOfBirthErrors;
        }

        let postcodeErrors = this.validatePostcode(data.postcode);
        if (postcodeErrors.length) {
          errors.postcode = postcodeErrors;
        }

        if (!data.termsAndConditions) {
          errors.termsAndConditions = 'Please tick this box to accept the terms and conditions';
        }

        let recaptchaError = this.validateRecaptcha(data.recaptchaToken);
        if (recaptchaError.length) {
          errors.recaptcha = recaptchaError;
        }
        return errors;
      },
      async checkDtaConfig() {
        await this.$store.dispatch('onboarding/GET_DTA_CONFIG').then((response) => {
          if (localStorage.ffaPlatform === CognitoPlatforms.PlayFootball) {
            this.dta.info = response.data.config.signup_dta_text;
            this.dta.isFromRego = response.data.config.signup_dta_status === '1';
          }
        }).catch(errors => {
          // console.error(errors);
        });
      },
      onCaptchaVerified: function (recaptchaToken) {
        this.data.recaptchaToken = recaptchaToken;
        let validate = this.validateRecaptcha(recaptchaToken);
        if (validate.length) {
          this.errors.recaptcha = recaptchaError;
        } else {
          this.errors.recaptcha = '';
        }
      },
      onCaptchaExpired: function () {
        this.$refs.recaptcha.reset();
        this.data.recaptchaToken = "";
      }
    }
  };
</script>